import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './date-range-input.module.scss'

interface IDateRangeInputProps {
    dateFrom: string
    dateTo: string
    onDateChange: ReturnType<typeof onDateChange>
}

export const onDateChange =
    (
        setDateFrom: Dispatch<SetStateAction<string>>,
        setDateTo: Dispatch<SetStateAction<string>>
    ) =>
    (field: string, value: string) => {
        if (field === 'date_from') {
            setDateFrom(value ? new Date(value).toISOString() : '')
        }
        if (field === 'date_to') {
            setDateTo(value ? new Date(value).toISOString() : '')
        }
    }

function DateRangeInput(props: IDateRangeInputProps) {
    const { dateFrom, dateTo, onDateChange } = props
    const { t } = useTranslation()

    const dateFromValue = dateFrom.slice(0, 10)
    const dateToValue = dateTo.slice(0, 10)
    const todayDateValue = new Date().toISOString().slice(0, 10)

    return (
        <div className={styles.datesRange__dates}>
            <p>{t('dates_scope')}</p>
            <div className={styles.datesRange__datesInnerWrapper}>
                <div className={styles.datesRange__dateWrapper}>
                    <label
                        className={styles.datesRange__dateLabel}
                        htmlFor="dateFrom"
                    >
                        {t('from')}
                    </label>
                    <input
                        className={styles.datesRange__dateInput}
                        type="date"
                        value={dateFromValue ? dateFromValue : ''}
                        max={dateToValue ? dateToValue : todayDateValue}
                        onChange={(e) =>
                            onDateChange('date_from', e.target.value)
                        }
                    />
                </div>
                <div className={styles.datesRange__dateWrapper}>
                    <label
                        className={styles.datesRange__dateLabel}
                        htmlFor="dateTo"
                    >
                        {t('to')}
                    </label>
                    <input
                        className={styles.datesRange__dateInput}
                        name="dateTo"
                        type="date"
                        min={dateFromValue ? dateFromValue : undefined}
                        max={todayDateValue}
                        value={dateToValue ? dateToValue : ''}
                        onChange={(e) =>
                            onDateChange('date_to', e.target.value)
                        }
                    />
                </div>
            </div>
        </div>
    )
}

export default DateRangeInput
